<!-- eslint-disable max-len -->
<template>
  <teleport to="body">
    <div
      v-if="shown"
      name="dialogBlock"
      class="fixed inset-0 z-40 h-full w-full bg-neutral-500 opacity-50"
      @click="emit('update:shown', false)"
    ></div>
    <div
      v-if="shown"
      class="fixed inset-0 z-50 m-auto flex h-fit max-h-[90vh] max-w-max flex-col rounded-3xl bg-slate-200 p-6 dark:bg-neutral-700"
      name="dialog"
    >
      <h2 class="text-xl font-extrabold tracking-tight">{{ title }}</h2>
      <div v-if="text">
        {{ text }}
      </div>

      <form class="flex flex-col overflow-y-auto p-1" @submit.prevent="callback">
        <slot></slot>
        <div class="mt-4 flex justify-between gap-2">
          <button
            class="rounded-xl bg-neutral-600 px-2 py-1 font-semibold hover:bg-neutral-500"
            type="submit"
          >
            {{ btnPositive.text }}
          </button>
          <button
            v-if="btnNegative"
            class="rounded-xl bg-neutral-600 px-2 py-1 font-semibold hover:bg-neutral-500"
            type="reset"
            @click="
              () => {
                emit('update:shown', false);
                if (btnNegative!.callback) btnNegative!.callback();
              }
            "
          >
            {{ btnNegative.text }}
          </button>
        </div>
      </form>
    </div>
  </teleport>
</template>

<script setup lang="ts">
type voidFunction = (event?: Event) => void;

defineProps<{
  shown: boolean;
  text?: string;
  title: string;
  callback?: voidFunction;
  btnPositive: { text: string };
  btnNegative?: { text: string; callback?: voidFunction };
}>();
const emit = defineEmits(["update:shown"]);
</script>

<style scoped></style>
